import React from 'react';
import '../../styles/shared/LoadingSpinner.css';

function LoadingSpinner({ size = 'medium', text = 'Loading...' }) {
  return (
    <div className={`loading-spinner loading-spinner--${size}`}>
      <div className="spinner-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      {text && <p className="loading-spinner__text">{text}</p>}
    </div>
  );
}

export default LoadingSpinner;
